(() => {
  /* Tab pill: at the top of the page the first tab (Specs) is the active one */
  const nav = document.querySelector('.bezelor-pdp-tabs');
  const resetPill = () => {
    if (!nav || window.scrollY > 40) return;
    [...nav.querySelectorAll('a[href^="#"]')].forEach((link, i) => {
      link.classList.toggle('is-active', i === 0);
      if (i === 0) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current');
    });
  };
  resetPill();
  document.addEventListener('DOMContentLoaded', resetPill);
  window.addEventListener('load', () => { resetPill(); setTimeout(resetPill, 400); setTimeout(resetPill, 1400); });

  /* Estimated delivery: dispatch in 1-2 business days, then the transit window for the shopper's country
     (the same figures as the shipping policy, read from the promise line in the page). */
  const addBusinessDays = (from, days) => {
    const date = new Date(from);
    while (days > 0) { date.setDate(date.getDate() + 1); const day = date.getDay(); if (day !== 0 && day !== 6) days -= 1; }
    return date;
  };
  const month = (date) => date.toLocaleDateString('en-GB', { month: 'short' });
  const range = (a, b) => (a.getMonth() === b.getMonth()
    ? a.getDate() + ' – ' + b.getDate() + ' ' + month(b)
    : a.getDate() + ' ' + month(a) + ' – ' + b.getDate() + ' ' + month(b));
  const addEta = () => {
    const ship = document.querySelector('.bz-pdp-promise__ship');
    const min = parseInt(ship && ship.dataset.transitMin, 10) || 7;
    const max = parseInt(ship && ship.dataset.transitMax, 10) || 20;
    const today = new Date();
    const text = range(addBusinessDays(today, 1 + min), addBusinessDays(today, 2 + max));
    document.querySelectorAll('[data-bz-policy-open="shipping"] .bz-service-row-text').forEach((box) => {
      if (box.querySelector('.bz-eta')) return;
      const line = document.createElement('span');
      line.className = 'bz-eta';
      line.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="5" width="16" height="15" rx="2"/><path d="M4 10h16M8 3v4M16 3v4"/></svg>';
      const label = document.createElement('span');
      label.append('Est. delivery ');
      const strong = document.createElement('b');
      strong.textContent = text;
      label.append(strong);
      line.append(label);
      box.append(line);
    });
  };
  addEta();
  document.addEventListener('DOMContentLoaded', addEta);
})();
